module.exports = {"411722001":"蔡都街道","411722002":"芦岗街道","411722003":"重阳街道","411722004":"卧龙街道","411722101":"黄埠镇","411722102":"杨集镇","411722103":"洙湖镇","411722104":"党店镇","411722105":"朱里镇","411722106":"华陂镇","411722107":"塔桥镇","411722108":"东洪镇","411722109":"邵店镇","411722110":"五龙镇","411722111":"和店镇","411722112":"韩寨镇","411722113":"蔡沟镇","411722201":"大路李乡","411722202":"无量寺乡","411722205":"杨屯乡","411722209":"齐海乡","411722210":"崇礼乡","411722212":"东岸乡","411722215":"小岳寺乡","411722216":"西洪乡","411722217":"百尺乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411722.json
// module id = 1811
// module chunks = 0